import { apiUrl } from '@kidstube/lib/api';

export default function LoginPage() {
  const loginUrl = apiUrl(`/api/auth/login?returnTo=${encodeURIComponent(window.location.href)}`);

  return (
    <div className="loading-screen">
      <div className="loading-logo">🎬</div>
      <h1 style={{ marginBottom: 'var(--spacing-md)' }}>Welcome to KidsTube</h1>
      <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-muted)' }}>
        Sign in with Google to continue.
      </p>
      <a className="btn btn-primary" href={loginUrl}>
        Continue with Google
      </a>
    </div>
  );
}
